import React, {useMemo} from 'react';
import {add, endOfDay, startOfDay} from "date-fns";

import Typography from "@mui/material/Typography";
import CalendarToday from '@mui/icons-material/CalendarToday';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Container from "@mui/material/Container";

import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from "@mui/lab";

import BookingCard from "../BookingCard";
import {OptionalContent} from "../../../components/OptionalContent";
import {DateFormatter} from "../../../services/date";

const groupBy = (arr, f) => {
    return arr.reduce((acc, item) => {
        acc[f(item)] = acc[f(item)] || [];
        acc[f(item)].push(item);
        return acc;
    }, {});
}

const Arrivals = ({bookings, accommodations}) => {
    const today = startOfDay(new Date());

    const arrivals = useMemo(() => {
        const startDate = startOfDay(new Date());
        const endDate = endOfDay(add(today, {'days': 10}))
        return bookings.filter(b => b.getArrival() >= startDate && b.getArrival() <= endDate).sort((a, b) => a.getArrival() - b.getArrival())
    }, [bookings])

    let arrivalByDate = {
        [today.toISOString()]: [],
        ...groupBy(arrivals, b => startOfDay(b.getArrival()).toISOString()),
    }

    const timeLineItems = Object.keys(arrivalByDate)
        .sort()
        .map(date => ({
            label: `${date === today.toString() ? 'Oggi, ' : ''} ${DateFormatter.longStringWithDayName(new Date(date))}`,
            bookings: arrivalByDate[date],
        }))

    return (
        <Container maxWidth='md' disableGutters sx={{display: 'flex', flexDirection: 'column', minHeight: '450px'}}>
            <OptionalContent hasContent={arrivals.length > 0}
                             noContentMessage="Nessun arrivo nei prossimi 10 giorni"
                             showIcon>
                <Timeline sx={{p: '6px 8px'}}>
                    {
                        timeLineItems.map(({label, bookings}, i) => (
                            <TimelineItem key={i}>
                                <TimelineOppositeContent sx={{flex: '0 1', padding: 0}}/>

                                <TimelineSeparator>
                                    <TimelineDot color={i === 0 ? "primary" : 'grey'}>
                                        <CalendarToday fontSize='14px'/>
                                    </TimelineDot>
                                    <TimelineConnector/>
                                </TimelineSeparator>

                                <TimelineContent sx={{padding: {xs: '14px 8px 6px', md: '14px 16px'}}}>

                                    <Typography variant='body1' sx={{mb: 2}}>{label}</Typography>
                                    {
                                        bookings.map((b, j) => (
                                            <BookingCard key={j} booking={b} accommodations={accommodations}/>
                                        ))
                                    }

                                </TimelineContent>
                            </TimelineItem>
                        ))
                    }
                    <TimelineItem>
                        <TimelineOppositeContent sx={{flex: '0 1', padding: 0}}/>
                        <TimelineSeparator>
                            <TimelineDot color="grey">
                                <MoreHorizIcon fontSize='14px'/>
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent/>
                    </TimelineItem>
                </Timeline>
            </OptionalContent>
        </Container>
    );
};

export default Arrivals;